import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { scrollTo } from "@/js/animation";
import { getLoggedUserData, isAdminNotConsultant, isTokenExpired } from "@/js/http/auth";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import * as reporting from "@/js/reporting/reporting.js";
import { formatPrice } from "@/js/currency/currencies.js";
var WINERY_DASHBOARD_VISIT = "wineryDashboardVisit";
var NB_MAX_FOR_REFERENCE_CHARTS = 50;
var customerColumnTurnoverDef = {
  text: "Turnover (€)",
  value: "totalTurnoverExVatEuro",
  align: "center",
  cellClass: "text-nowrap"
};
var customerDetailColumnTurnoverDef = {
  text: "Turnover (€)",
  value: "totalTurnoverExVatEuro",
  align: "center",
  cellClass: "text-nowrap"
};
var customerDetailColumnCogsDef = {
  text: "Cogs (€)",
  value: "wineCogs",
  align: "center",
  cellClass: "text-nowrap"
};
export default {
  name: "PublicWineryDashboard",
  components: {
    DatePicker: DatePicker
  },
  data: function data() {
    return {
      wineryDashboard: null,
      init: {
        guid: null,
        isLoading: false
      },
      visit: {
        form: {
          name: "",
          valid: false
        },
        isCreating: false,
        data: null
      },
      indicators: {
        cancellationToken: null,
        isGenerating: false,
        isLoaded: false,
        form: {
          dateEnd: null,
          dateStart: null
        },
        data: null,
        detailedView: {
          isShown: false,
          destinations: {
            turnover: {
              headers: [{
                text: "Country",
                value: "text",
                align: "left"
              }, {
                text: "€",
                value: "value",
                align: "left"
              }],
              data: []
            },
            volume: {
              headers: [{
                text: "Country",
                value: "text",
                align: "left"
              }, {
                text: "Btl",
                value: "value",
                align: "left"
              }],
              data: []
            },
            orders: {
              headers: [{
                text: "Country",
                value: "text",
                align: "left"
              }, {
                text: "Orders",
                value: "value",
                align: "left"
              }],
              data: []
            }
          },
          customerTypes: {
            turnover: {
              headers: [{
                text: "Type",
                value: "text",
                align: "left"
              }, {
                text: "€",
                value: "value",
                align: "left"
              }],
              data: []
            },
            volume: {
              headers: [{
                text: "Type",
                value: "text",
                align: "left"
              }, {
                text: "Btl",
                value: "value",
                align: "left"
              }],
              data: []
            },
            orders: {
              headers: [{
                text: "Type",
                value: "text",
                align: "left"
              }, {
                text: "Orders",
                value: "value",
                align: "left"
              }],
              data: []
            }
          },
          references: {
            turnover: {
              headers: [{
                text: "Reference",
                value: "text",
                align: "left"
              }, {
                text: "€",
                value: "value",
                align: "left"
              }],
              data: []
            },
            volume: {
              headers: [{
                text: "Reference",
                value: "text",
                align: "left"
              }, {
                text: "Btl",
                value: "value",
                align: "left"
              }],
              data: []
            },
            orders: {
              headers: [{
                text: "Reference",
                value: "text",
                align: "left"
              }, {
                text: "Orders",
                value: "value",
                align: "left"
              }],
              data: []
            }
          }
        },
        destinations: {
          tab: null
        },
        customerTypes: {
          tab: null
        },
        references: {
          tab: null
        },
        customers: {
          mainTableHeaders: [{
            text: "Name",
            value: "user.displayName",
            align: "left"
          }, {
            text: "Type",
            value: "userGroupName",
            align: "center",
            sortable: false
          }, {
            text: "Localisation",
            value: "userMainAddress",
            align: "left",
            sortable: false,
            cellClass: "text-nowrap"
          }, {
            text: "Volume (btl)",
            value: "totalQuantity",
            align: "center",
            cellClass: "text-nowrap"
          }, {
            text: "Orders",
            value: "nbOrders",
            align: "center"
          }, {
            text: "Actions",
            value: "actions",
            align: "right",
            sortable: false,
            cellClass: "text-nowrap"
          }],
          detailTable: {
            title: "",
            items: null,
            headers: [{
              text: "Wine",
              value: "wine.displayName",
              align: "left"
            }, {
              text: "Volume (btl)",
              value: "totalQuantity",
              align: "center",
              cellClass: "text-nowrap"
            }, {
              text: "Orders",
              value: "nbOrders",
              align: "center"
            }, {
              text: "Av. sale price inc. shipping (€)",
              value: "averageUnitSalePriceExVatEuroIncludeShipping",
              align: "center",
              cellClass: "text-nowrap"
            }]
          }
        },
        exportingCancellationToken: null,
        isExporting: false
      },
      loggedUserData: {},
      clientData: {
        client_id: this.$whitelabel.clientId,
        client_secret: this.$whitelabel.clientSecret
      },
      formatPrice: formatPrice,
      formRules: formRules,
      NB_MAX_FOR_REFERENCE_CHARTS: NB_MAX_FOR_REFERENCE_CHARTS
    };
  },
  computed: {
    isAuthorized: function isAuthorized() {
      var _this$wineryDashboard;
      return !!this.wineryDashboard && (((_this$wineryDashboard = this.wineryDashboard) === null || _this$wineryDashboard === void 0 ? void 0 : _this$wineryDashboard.isActive) || isAdminNotConsultant(this.loggedUserData));
    },
    isRequestFinishedWithError: function isRequestFinishedWithError() {
      return !this.loading.isComplete && this.errorMessage;
    },
    isShowTurnover: function isShowTurnover() {
      var _this$indicators;
      return (_this$indicators = this.indicators) === null || _this$indicators === void 0 || (_this$indicators = _this$indicators.data) === null || _this$indicators === void 0 ? void 0 : _this$indicators.isShowTurnover;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$$route$params, _this2$visit$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.init.isLoading = true;
            _this2.init.guid = (_this2$$route$params = _this2.$route.params) === null || _this2$$route$params === void 0 ? void 0 : _this2$$route$params.guid;
            _this2.loggedUserData = getLoggedUserData();
            _context.next = 5;
            return _this2.fetchMainWineryDashboard();
          case 5:
            _this2.getLocalStorageVisit();
            _this2.indicators.form.dateEnd = moment().startOf("month").format("YYYY-MM-DD");
            _this2.indicators.form.dateStart = moment().startOf("month").subtract(1, "year").format("YYYY-MM-DD");
            _this2.init.isLoading = false;
            if (isAdminNotConsultant(_this2.loggedUserData) || !!((_this2$visit$data = _this2.visit.data) !== null && _this2$visit$data !== void 0 && _this2$visit$data.guid)) {
              _this2.searchIndicators();
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchMainWineryDashboard: function fetchMainWineryDashboard() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/winery-dashboards/".concat(_this3.init.guid, "/access"), "post", _this.clientData, false, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this3.wineryDashboard = _objectSpread({}, response.data.value);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setLocalStorageVisit: function setLocalStorageVisit() {
      if (!this.isAdminNotConsultant(this.loggedUserData)) {
        var data = {
          dashboardGuid: this.wineryDashboard.guid,
          visitData: _objectSpread({}, this.visit.data)
        };
        localStorage.setItem(WINERY_DASHBOARD_VISIT, JSON.stringify(data));
      }
    },
    getLocalStorageVisit: function getLocalStorageVisit() {
      if (!this.isAdminNotConsultant(this.loggedUserData)) {
        var stringifiedVisit = localStorage.getItem(WINERY_DASHBOARD_VISIT);
        if (stringifiedVisit) {
          var data = JSON.parse(stringifiedVisit);
          if (data.dashboardGuid === this.wineryDashboard.guid) {
            this.visit.data = _objectSpread({}, data.visitData);
          } else {
            this.clearLocalStorageVisit();
          }
        }
      }
    },
    clearLocalStorageVisit: function clearLocalStorageVisit() {
      localStorage.removeItem(WINERY_DASHBOARD_VISIT);
    },
    createVisit: function createVisit() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.visit.isCreating = true;
              _this = _this4;
              data = _objectSpread(_objectSpread({}, _this4.clientData), _this4.visit.form);
              delete data.valid;
              _context3.next = 6;
              return request("/v1/winery-dashboards/".concat(_this4.init.guid, "/visit"), "post", data, false, "api").catch(function (e) {
                _this.visit.isCreating = false;
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 6:
              response = _context3.sent;
              _this4.visit.isCreating = false;
              _this4.visit.data = {
                guid: response.data.value
              };
              _this4.setLocalStorageVisit();
              _this4.searchIndicators();
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    searchIndicators: function searchIndicators() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$visit, _this5$indicators$can;
        var params, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.indicators.isGenerating = true;
              _this5.indicators.isLoaded = false;
              if (_this5.indicators.data) {
                reporting.disposeCharts();
                _this5.indicators.data = null;
                _this5.hideDetailsOfCustomer();
              }
              params = _objectSpread(_objectSpread({}, _this5.indicators.form), !_this5.isAdminNotConsultant(_this5.loggedUserData) && {
                visitGuid: (_this5$visit = _this5.visit) === null || _this5$visit === void 0 || (_this5$visit = _this5$visit.data) === null || _this5$visit === void 0 ? void 0 : _this5$visit.guid
              });
              paramsQuery = Object.encodeToUri(params);
              (_this5$indicators$can = _this5.indicators.cancellationToken) === null || _this5$indicators$can === void 0 || _this5$indicators$can.cancel();
              _this5.indicators.cancellationToken = axios.CancelToken.source();
              _this = _this5;
              _context4.next = 10;
              return request("/v1/winery-dashboards/".concat(_this5.wineryDashboard.guid, "/indicators?params=").concat(paramsQuery), "post", _this.clientData, false, "api", null, _this.indicators.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                  _this.indicators.isGenerating = false;
                }
                throw e;
              });
            case 10:
              response = _context4.sent;
              _this5.indicators.data = _objectSpread({}, response.data.value);
              _context4.next = 14;
              return _this5.adaptTableHeadersToShowTurnover();
            case 14:
              if (_this5.indicators.data.nbOrders > 0) {
                if (_this5.isShowTurnover) _this5.createChartDestinationsTurnoverWhenTabReady();
                _this5.createChartDestinationsVolumeWhenTabReady();
                _this5.createChartDestinationsOrdersWhenTabReady();
                if (_this5.isShowTurnover) _this5.createChartCustomerTypesTurnoverWhenTabReady();
                _this5.createChartCustomerTypesVolumeWhenTabReady();
                _this5.createChartCustomerTypesOrdersWhenTabReady();
                if (_this5.isShowTurnover) _this5.createChartReferencesTurnoverWhenTabReady();
                _this5.createChartReferencesVolumeWhenTabReady();
                _this5.createChartReferencesOrdersWhenTabReady();
              }
              _this5.indicators.isGenerating = false;
              _this5.indicators.isLoaded = true;
              if (_this5.indicators.data.nbOrders > 0) {
                _this5.$nextTick(function () {
                  scrollTo(".indicators-global-container");
                });
              }
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    adaptTableHeadersToShowTurnover: function adaptTableHeadersToShowTurnover() {
      if (this.isShowTurnover) {
        if (!this.indicators.customers.mainTableHeaders.some(function (x) {
          return x.value === customerColumnTurnoverDef.value;
        })) {
          this.indicators.customers.mainTableHeaders.splice(3, 0, customerColumnTurnoverDef);
        }
        if (!this.indicators.customers.detailTable.headers.some(function (x) {
          return x.value === customerDetailColumnTurnoverDef.value;
        })) {
          this.indicators.customers.detailTable.headers.splice(1, 0, customerDetailColumnTurnoverDef);
          this.indicators.customers.detailTable.headers.splice(4, 0, customerDetailColumnCogsDef);
        }
      } else {
        this.indicators.customers.mainTableHeaders = this.indicators.customers.mainTableHeaders.filter(function (x) {
          return x.value !== customerColumnTurnoverDef.value;
        });
        this.indicators.customers.detailTable.headers = this.indicators.customers.detailTable.headers.filter(function (x) {
          return x.value !== customerDetailColumnTurnoverDef.value && x.value !== customerDetailColumnCogsDef.value;
        });
      }
    },
    createChartDestinationsTurnoverWhenTabReady: function createChartDestinationsTurnoverWhenTabReady() {
      if (this.$refs.chartDestinationsTurnover) {
        var data = this.indicators.data.indicatorsByCountry.countries.map(function (x) {
          return {
            text: x.country.name,
            value: x.totalTurnoverExVatEuro
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.destinations.turnover.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartDestinationsTurnover);
      } else {
        setTimeout(this.createChartDestinationsTurnoverWhenTabReady, 100);
      }
    },
    createChartDestinationsVolumeWhenTabReady: function createChartDestinationsVolumeWhenTabReady() {
      if (this.$refs.chartDestinationsVolume) {
        var data = this.indicators.data.indicatorsByCountry.countries.map(function (x) {
          return {
            text: x.country.name,
            value: x.totalQuantity
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.destinations.volume.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartDestinationsVolume);
      } else {
        setTimeout(this.createChartDestinationsVolumeWhenTabReady, 100);
      }
    },
    createChartDestinationsOrdersWhenTabReady: function createChartDestinationsOrdersWhenTabReady() {
      if (this.$refs.chartDestinationsOrders) {
        var data = this.indicators.data.indicatorsByCountry.countries.map(function (x) {
          return {
            text: x.country.name,
            value: x.nbOrders
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.destinations.orders.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartDestinationsOrders);
      } else {
        setTimeout(this.createChartDestinationsOrdersWhenTabReady, 100);
      }
    },
    createChartCustomerTypesTurnoverWhenTabReady: function createChartCustomerTypesTurnoverWhenTabReady() {
      if (this.$refs.chartCustomerTypesTurnover) {
        var data = this.indicators.data.indicatorsByCustomerType.groups.map(function (x) {
          return {
            text: x.userGroupName,
            value: x.totalTurnoverExVatEuro
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.customerTypes.turnover.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartCustomerTypesTurnover);
      } else {
        setTimeout(this.createChartCustomerTypesTurnoverWhenTabReady, 100);
      }
    },
    createChartCustomerTypesVolumeWhenTabReady: function createChartCustomerTypesVolumeWhenTabReady() {
      if (this.$refs.chartCustomerTypesVolume) {
        var data = this.indicators.data.indicatorsByCustomerType.groups.map(function (x) {
          return {
            text: x.userGroupName,
            value: x.totalQuantity
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.customerTypes.volume.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartCustomerTypesVolume);
      } else {
        setTimeout(this.createChartCustomerTypesVolumeWhenTabReady, 100);
      }
    },
    createChartCustomerTypesOrdersWhenTabReady: function createChartCustomerTypesOrdersWhenTabReady() {
      if (this.$refs.chartCustomerTypesOrders) {
        var data = this.indicators.data.indicatorsByCustomerType.groups.map(function (x) {
          return {
            text: x.userGroupName,
            value: x.nbOrders
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        this.indicators.detailedView.customerTypes.orders.data = _toConsumableArray(data);
        reporting.showPieChartIndicators(data, this.$refs.chartCustomerTypesOrders);
      } else {
        setTimeout(this.createChartCustomerTypesOrdersWhenTabReady, 100);
      }
    },
    createChartReferencesTurnoverWhenTabReady: function createChartReferencesTurnoverWhenTabReady() {
      if (this.$refs.chartReferencesTurnover) {
        var data = this.indicators.data.indicatorsByReference.references.map(function (x) {
          return {
            text: x.wine.displayName,
            value: x.totalTurnoverExVatEuro
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        }).slice(0, NB_MAX_FOR_REFERENCE_CHARTS);
        this.indicators.detailedView.references.orders.data = _toConsumableArray(data);
        reporting.showBarChartReferences(data, this.$refs.chartReferencesTurnover, "€");
      } else {
        setTimeout(this.createChartReferencesTurnoverWhenTabReady, 100);
      }
    },
    createChartReferencesVolumeWhenTabReady: function createChartReferencesVolumeWhenTabReady() {
      if (this.$refs.chartReferencesVolume) {
        var data = this.indicators.data.indicatorsByReference.references.map(function (x) {
          return {
            text: x.wine.displayName,
            value: x.totalQuantity
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        }).slice(0, NB_MAX_FOR_REFERENCE_CHARTS);
        this.indicators.detailedView.references.volume.data = _toConsumableArray(data);
        reporting.showBarChartReferences(data, this.$refs.chartReferencesVolume, "btl");
      } else {
        setTimeout(this.createChartReferencesVolumeWhenTabReady, 100);
      }
    },
    createChartReferencesOrdersWhenTabReady: function createChartReferencesOrdersWhenTabReady() {
      if (this.$refs.chartReferencesOrders) {
        var data = this.indicators.data.indicatorsByReference.references.map(function (x) {
          return {
            text: x.wine.displayName,
            value: x.nbOrders
          };
        }).sort(function (a, b) {
          return b.value - a.value;
        }).slice(0, NB_MAX_FOR_REFERENCE_CHARTS);
        this.indicators.detailedView.references.orders.data = _toConsumableArray(data);
        reporting.showBarChartReferences(data, this.$refs.chartReferencesOrders, "");
      } else {
        setTimeout(this.createChartReferencesOrdersWhenTabReady, 100);
      }
    },
    showDetailsOfCustomer: function showDetailsOfCustomer(customerData) {
      this.indicators.customers.detailTable.items = null;
      this.indicators.customers.detailTable.title = "References bought by \"".concat(customerData.user.displayName, "\"");
      this.indicators.customers.detailTable.items = customerData.detailsOfReferences.references;
      this.$nextTick(function () {
        scrollTo("#detailsOfCustomerDiv");
      });
    },
    hideDetailsOfCustomer: function hideDetailsOfCustomer() {
      this.indicators.customers.detailTable.title = "";
      this.indicators.customers.detailTable.items = null;
    },
    exportIndicators: function exportIndicators() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$visit, _this6$indicators$exp;
        var dateStartFormatted, dateEndFormatted, fileName, params, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.indicators.isExporting = true;
              dateStartFormatted = moment(_this6.indicators.form.dateStart, "YYYYMMDD").format("YYYYMMDD");
              dateEndFormatted = moment(_this6.indicators.form.dateEnd, "YYYYMMDD").format("YYYYMMDD");
              fileName = "CM-DASHBOARD-".concat(dateStartFormatted, "-to-").concat(dateEndFormatted, ".xlsx");
              params = _objectSpread(_objectSpread({}, _this6.indicators.form), !_this6.isAdminNotConsultant(_this6.loggedUserData) && {
                visitGuid: (_this6$visit = _this6.visit) === null || _this6$visit === void 0 || (_this6$visit = _this6$visit.data) === null || _this6$visit === void 0 ? void 0 : _this6$visit.guid
              });
              paramsQuery = Object.encodeToUri(params);
              (_this6$indicators$exp = _this6.indicators.exportingCancellationToken) === null || _this6$indicators$exp === void 0 || _this6$indicators$exp.cancel();
              _this6.indicators.exportingCancellationToken = axios.CancelToken.source();
              _this = _this6;
              _context5.next = 11;
              return request("/v1/winery-dashboards/".concat(_this6.wineryDashboard.guid, "/export-indicators?params=").concat(paramsQuery), "post", _this.clientData, true, "api", "blob", _this.indicators.exportingCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                  _this.indicators.isExporting = false;
                }
                throw e;
              });
            case 11:
              response = _context5.sent;
              _this6.indicators.isExporting = false;
              fileDownload(response.data, fileName, "application/xlsx");
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    routeToContact: function routeToContact() {
      return {
        name: !isTokenExpired() ? "userContact" : "contact"
      };
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isTokenExpired: isTokenExpired
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.clearLocalStorageVisit();
    if (this.indicators.data) {
      reporting.disposeCharts();
    }
    next();
  }
};